import { isFetchCollectionResultSuccessful } from '@/entities/FetchResult'
import { getSettingsApiCall } from '@/entities/Setting/SettingService'
import { reportError } from '@/helpers/errorReporting'
import { TypedDispatch } from '@/store'

import { setError, setIsLoading, setSettings } from './settingsReducer'

export const fetchSettings = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(undefined))

    try {
        const response = await getSettingsApiCall()

        if (! isFetchCollectionResultSuccessful(response)) {
            dispatch(setError(response))

            return
        }

        dispatch(setSettings(response.data))
    } catch (error) {
        reportError('fetchSettings', error)
    }

    dispatch(setIsLoading(false))
}
